export const getAuth0 = () => typeof window !== 'undefined' && window.auth0;
